import WebModel from '../models/WebModel'

const defaultSidebarWidth = 1100

export const getBaseStyles = ({
  adhesion_light,
  custom_css,
  recipe_float,
  bidders,
  sidebar_minimum_width
}: WebModel) =>
  `
  .mv-empty-wrapper {
    margin: 0 !important;
    height: 0px !important;
    min-height: unset !important;
  }
  .adunitwrapper {
    overflow: hidden;
  }

  .adunitlabel {
    display: none;
  }

  .adhesion_wrapper {
    display : none;
    max-height: 90px!important;
  }

  .mv-native-size > div, 
  .mv-native-size div[id^='google_ads'] {
    min-height: 100%!important;
    height: 100%!important;
    width: 100%!important;
  }

  .mv-dynamic-size > div, 
  .mv-dynamic-size div[id^='google_ads'] {
    height: initial!important;
    width: initial!important;
  }


  .adunitlabel {
    color: #a5a5a5;
    font-size : 12px !important;
    line-height : 12px !important;
    text-align : left;
  }
  .adunitlabel .mediavine {
    padding-top : 2px !important;
  }

  body.adhesion {
    padding-bottom: 90px!important;
  }

  .mediavine img {
    margin : 0 !important;
    padding : 0 !important;
    border : 0 !important;
    box-shadow: none !important;
  }

  .adunitlabel a {
    color: #a5a5a5;
    text-decoration : none;
  }
  .adunitlabel .mv-ad-report-button {
    float : right;
    cursor: pointer;
  }

  .sidebar_btf_wrapper {
    margin : 0 auto 0 auto;
    width : 300px;
  }

  .recipe_mobile_wrapper,
  .content_mobile_wrapper,
  .comments_mobile_wrapper {
    margin-bottom : 10px;
  }

  @media (max-width: ${(sidebar_minimum_width || defaultSidebarWidth) - 1}px) {
    #sidebar_btf_sticky_wrapper, .sidebar_btf_wrapper {
      display : none !important;
    }
  }


  .mv-create-target { 
    max-width: 300px !important;
  }

  .adunit a,
  .adunit object,
  .adunit embed,
  .adunit img,
  .adunit div,
  .adunit iframe {
    margin: 0 auto !important;
    text-align: center;
  }


  .content_btf_wrapper {
    margin : 10px auto 20px auto;
  }

  .content_btf_wrapper.native,
  .content_mobile_wrapper.native {
    max-width : 600px;
  }

  .content_float_right {
    margin : 0 0 10px 20px;
    float : right;
  }

  .content_mobile_wrapper,
  .recipe_mobile_wrapper,
  .comments_mobile_wrapper,
  .comments_btf_wrapper,
  .comments_mobile_wrapper,
  .content_btf_wrapper,
  .feed_mobile_wrapper,
  .feed_btf_wrapper {
    margin : 10px auto 20px auto;
    text-align : center;
  }

  .leaderboard_atf_wrapper,
  .sidebar_atf_wrapper,
  .leaderboard_btf_wrapper {
    margin : 0px auto 20px auto;
    text-align : center;
  }
  .leaderboard_btf_wrapper {
    margin-top : 20px;
  }

  @media (max-width : 727px) {
    .leaderboard_atf_wrapper {
      display : none !important;
    }
  }

  .adhesion_wrapper.adhesion_container {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    text-align: center;
    width: 100% !important;
    z-index: 2147483646;

    display: flex;
    flex-direction: row;
    lign-items: center;
    justify-content: center;

    ${
      adhesion_light
        ? `background-color: rgba(250, 250, 250, 0.9);`
        : `background-color: rgba(0, 0, 0, 0.9);`
    }
  }

  .adhesion_wrapper div {
    margin: 0px;
  }

  .adhesion_wrapper .adhesion_buttons {
    height: 100%;

    max-width: 48px;
    width: 48px;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .adhesion_wrapper .mv_close_button {
    width: 48px;
    display: flex;
    justify-content: center;
    cursor: pointer; 
    text-align: center !important;
  }

  .adhesion_wrapper .mv_unbutton {
    padding: unset;
    border: unset;
    background-color: transparent;
  }

  .adhesion_wrapper .mv_unbutton object {
    width: 20px;
    vertical-align: middle;
    pointer-events: none;
    margin: 0px;
  }


  /*Push Logo Up*/
  @media (max-width: 350px) {
    .adhesion_wrapper .adhesion_buttons {
      display: none;
    }
  }

  @media (min-width: 728px) and (max-width: 840px) {
    
  }

  @media (max-width: 727px) {
    body.adhesion {
      padding-bottom : 50px;
    }
    .adhesion_wrapper.adhesion_container {
      justify-content: center;
    }
  }

  @media (min-width: 728px) {
    body.adhesion {
      padding-bottom : 90px;
    }
  }

  ${
    recipe_float
      ? `
  .recipe_btf_wrapper {
    float : right;
    margin : 0 0 20px 20px !important;
  }
  `
      : `
  .recipe_btf_wrapper {
    width : 300px;
    margin : 20px 0 20px 0px !important;
  }`
  }

  @media print {
    .adunit,
    .adunitlabel,
    .adunitwrapper,
    .adhesion_wrapper {
      display : none !important;
    }
  }

  ${
    bidders.find((bidder) => bidder.name === 'triplelift')
      ? `
   .triplelift {
      margin-bottom : 5px !important;
    }

    .triplelift .entry-title {
      background : none !important;
      font-size : 18px;
      line-height : 22px;
      clear : none !important;
    }
    .triplelift .entry-content {
      clear : none !important;
      background : none !important;
    }
    .triplelift .entry-meta {
      display : block !important;
      background : none !important;
      clear : none !important;
      border : none !important;
      float : none !important;
    }
    .triplelift .entry-title a {
      line-height: inherit !important;
      float: none !important;
      width: auto !important;
      height: auto !important;
      background: none !important;
      color: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    `
      : ``
  }
  
  ${custom_css || ''}
`
